export class Materia {
  id: number;
  titulo: string;
  imagem$: Promise<Promise<string>>;
  imagem: string;
  link: string;
  buscouImagem: boolean;
  ativo: boolean;
  thumb: boolean;
  textothumb: string;
  mobile: boolean;
}
